// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'clashGrotesk', avenir, montserrat, corbel, URW Gothic, source-sans-pro, sans-serif"},"className":"__className_a7a356","variable":"__variable_a7a356"};